import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon, FlameIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, PRODUCT_IMAGE } from '../data/hero';
export function Hero() {
  return <header className="relative overflow-hidden bg-obsidian text-white" data-id="element-103" data-mp="9l341bdfia3g">
      <div className="mx-auto grid max-w-6xl gap-y-7 px-5 pb-14 pt-8 text-center lg:grid-cols-[1fr_1.1fr] lg:gap-x-12 lg:gap-y-8 lg:pb-20 lg:pt-16 lg:text-left" style={{
      paddingTop: "0px",
      paddingBottom: "10px",
      gap: "13px"
    }} data-id="element-104" data-mp="4mrt0xbedtjn">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-105" data-mp="xb5rfe6eervq">
          <h1 className="mt-4 font-display text-[46px] font-extrabold uppercase leading-[0.92] tracking-tight sm:text-6xl lg:text-[76px]" style={{
          fontSize: "36px"
        }} data-id="element-106" data-mp="sa9rtct2xrw4">
            Entrena con más estructura.
            <br data-id="element-107" data-mp="3d33ecx6girk8" />
            Organiza tu preparación.
            <br data-id="element-108" data-mp="381xmf1kmf8br" />
            <span className="text-electric" data-id="element-109" data-mp="381e2xgfbobvm">Afronta tu desafío con un plan más claro.</span>
          </h1>
          <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-white/70 sm:text-lg lg:mx-0" data-id="element-110" data-mp="3j9kbdcsl9jgn">
            Un sistema integral para organizar tu preparación, desde los entrenamientos, la estrategia y el día de competición
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-111" data-mp="3e9607lvoxtee">
          <img src={PRODUCT_IMAGE} alt="SISTEMA TRIATLÓN COMPLETO™ en tablet junto a los cuatro bonos complementarios" width={1536} height={1024} fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full max-w-[620px] drop-shadow-[0_30px_40px_rgba(20,125,255,0.18)]" data-id="element-112" data-mp="2qjv80ssep7bv" />
        </motion.div>

        <div className="lg:col-start-1 lg:row-start-2" data-id="element-113" data-mp="2lla68oxiaflb">
          <p className="text-sm font-semibold text-white" data-id="element-114" data-mp="2ljz5yz39rpyy">Sistema completo de 6 volúmenes + 4 bonos complementarios</p>
          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs text-white/60 lg:justify-start" data-id="element-115" data-mp="s3umzlkswo5c">
            <span className="flex items-center gap-1" data-id="element-116" data-mp="ibow6f6accrq">
              <span className="flex text-ember" aria-label="4,9 de 5 estrellas" data-id="element-117" data-mp="ia5kz2zhkrwt">
                {Array.from({
                length: 5
              }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-118" data-mp="1b15ntam2zpmw" data-mpi={k} />)}
              </span>
              <span className="font-semibold text-white" data-id="element-119" data-mp="162ufx5fcjp7b">4,9</span>
            </span>
            <span data-id="element-120" data-mp="111yd6v6qe93h">Unete a más de 400 atletas de élite y amateurs</span>
            <span className="inline-flex items-center gap-1" data-id="element-121" data-mp="x14mxv5tgi7f">
              <ZapIcon className="h-3.5 w-3.5 text-aqua" aria-hidden="true" data-id="element-122" data-mp="x0l8iofdkby5" /> Acceso inmediato
            </span>
          </p>

          <div className="mt-6 flex justify-center lg:justify-start" data-id="element-123" data-mp="3lqm4435bldx1">
            <CTAButton href="#pricing" data-id="element-124" data-mp="3hpsgzbzpc357">Ver el sistema completo</CTAButton>
          </div>

          <ul className="mt-6 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-125" data-mp="1xavymn782e8u">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/[0.04] px-3 py-1.5 text-xs font-medium text-white/80" data-id="element-126" data-mp="26a99nkazvavo">
                <Icon className="h-3.5 w-3.5 text-aqua" aria-hidden="true" data-id="element-127" data-mp="2b2snmidlg810" />
                {label}
              </li>)}
          </ul>

          <div className="mt-6 flex flex-col items-center gap-2 lg:items-start" data-id="element-128" data-mp="2kyduattlxwh3">
            <p className="inline-flex items-center gap-1.5 rounded-full border border-ember/35 bg-ember/10 px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-wide text-ember" data-id="element-129" data-mp="2p0h7bmvxd94h">
              <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-130" data-mp="2txhc7uh1g5u0" />
              Oferta por tiempo limitado · El precio volverá a subir tras el lanzamiento
            </p>
            <p className="flex items-center gap-1.5 text-xs text-white/45" data-id="element-131" data-mp="zm2n9fvuqafb">
              <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-132" data-mp="4acm5ch3dp7f" />
              15 personas están viendo este producto ahora
            </p>
          </div>
        </div>
      </div>
    </header>;
}